import { Dashboard } from "../dashboard"

export const SalesDashboard = ({pageSwap, courseToUpdate, setCourseToUpdate, AiStarted }) => {
    return(
        <Dashboard
            CustomerStage = {1}
            pageSwap={pageSwap}
            courseToUpdate={courseToUpdate}
            setCourseToUpdate={setCourseToUpdate}
            AiStarted={AiStarted}
            
        />
    )
}